export const IPIRANGA_PROMOTION_AVAILABLE = 'IPIRANGA_PROMOTION_AVAILABLE'
export const IPIRANGA_PROMOTION_RESET = 'IPIRANGA_PROMOTION_RESET'
export const IPIRANGA_PROMOTION_LIST_LOADED = 'IPIRANGA_PROMOTION_LIST_LOADED'
